import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getApiUrl } from '../config';
import { useNotification, Notification as NotificationComponent } from './Notification';
import { logger } from '../utils/logger';

const LeaveMatch: React.FC = () => {
  const { playerId, token } = useParams<{ playerId: string; token: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [playerData, setPlayerData] = useState<{ name: string; matchId: string } | null>(null);
  const [confirmed, setConfirmed] = useState(false);
  const { notification, showNotification, hideNotification } = useNotification();

  useEffect(() => {
    // Intentar obtener información del jugador del localStorage
    if (playerId) {
      const storedName = localStorage.getItem(`player_${playerId}_name`);
      const storedMatchId = localStorage.getItem(`player_${playerId}_matchId`);
      
      if (storedName && storedMatchId) {
        setPlayerData({ name: storedName, matchId: storedMatchId });
      }
    }
  }, [playerId]);

  const handleLeave = async () => {
    if (!playerId || !token) {
      showNotification('Link inválido', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(getApiUrl(`/api/players/${playerId}/leave/${token}`), {
        method: 'DELETE'
      });

      if (response.ok) {
        const result = await response.json();
        
        // Limpiar localStorage
        localStorage.removeItem(`player_${playerId}_leaveLink`);
        localStorage.removeItem(`player_${playerId}_name`);
        localStorage.removeItem(`player_${playerId}_matchId`);
        
        setConfirmed(true);
        showNotification(result.message, 'success');
      } else {
        const error = await response.json();
        showNotification(error.error || 'Error al darse de baja', 'error');
      }
    } catch (error) {
      logger.error('Error leaving match:', error);
      showNotification('Error al darse de baja del partido', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (confirmed) {
    return (
      <div className="container">
        <div className="header">
          <h1>✅ Te has dado de baja</h1>
        </div>
        <div className="card">
          <h2>¡Hasta la próxima, {playerData?.name}!</h2>
          <p>Te has dado de baja exitosamente del partido.</p>
          <p>Esperamos verte en futuros partidos. ⚽</p>
          
          <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'center' }}>
            <button 
              className="btn" 
              onClick={() => navigate('/home')}
            >
              🏠 Volver al Inicio
            </button>
            {playerData?.matchId && (
              <button 
                className="btn btn-secondary" 
                onClick={() => navigate(`/match/${playerData.matchId}`)}
              >
                👀 Ver Partido
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <NotificationComponent 
        message={notification.message}
        type={notification.type}
        isVisible={notification.isVisible}
        onClose={hideNotification}
      />
      <div className="header">
        <h1>🚪 Darse de Baja del Partido</h1>
      </div>
      <div className="card">
        <h2>Confirmar Baja</h2>
        <p>¿Estás seguro de que quieres darte de baja del partido?</p>
        <p><strong>Jugador:</strong> {playerData?.name || 'No identificado'}</p>
        
        <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'center' }}>
          <button 
            className="btn btn-danger" 
            onClick={handleLeave}
            disabled={loading}
          >
            {loading ? 'Procesando...' : 'Sí, darme de baja'}
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={() => navigate('/home')}
            disabled={loading}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveMatch; 